export const exprToConditionMapper = {
  "<": "less",
  "<=": "less_equal",
  ">=": "greater_equal",
  ">": "greater",
  "==": "equal"
};
export const conditionToExprMapper = {
  less: "<",
  less_equal: "<=",
  greater_equal: ">=",
  greater: ">",
  equal: "=="
};
